import { LandingPage } from "src/components/Home";
import { createGetServerSideProps } from "src/utilities/ssr/createGetServerSideProps";
import { getLandingPageServerSideProps } from "src/utilities/ssr/getLandingServerSideProps";
import { withPropsDeserialization } from "src/utilities/ssr/withPropsDeserialization";

export const getServerSideProps = createGetServerSideProps(
  getLandingPageServerSideProps
);

export default withPropsDeserialization(LandingPage);
